class s extends Event{constructor(s,e){super(s,{bubbles:!0,composed:!0,...e})}}export{s as N};
//# sourceMappingURL=events-731d0007.js.map
